import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SubmissionRecordObject } from '../../../shared/services/submission-history-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { ModalService } from '../../../shared/services/modal.service';
import { NotesComponent } from '../notes/notes.component';
import { NotesService } from '../../../shared/services/notes.service';
import {Subscription} from "rxjs";

@Component({
    selector: 'submInfo-Sidebar',
    templateUrl: './submInfo-Sidebar.component.html',
    styleUrls: [ './submInfo-Sidebar.component.scss' ]
})
export class SubmInfoSidebarComponent implements OnInit {

    activeFileRecord: SubmissionRecordObject;
    btnTrigger: any;
    activeNote: any;

    @ViewChild('notesComponentSubmissionInfo')
    private notesComponentSubmissionInfo: NotesComponent;

    constructor(private submissionHistoryService: SubmissionHistoryService,
                private modalService: ModalService,
                private readonly notesService: NotesService,
                private route: ActivatedRoute) {
        this.route.params.subscribe(res => this.getSampleSubmissionData(res.id));
    }

    ngOnInit() {
        this.submissionHistoryService.currentSampleSubmissionData.subscribe(message => {
            this.activeFileRecord = message;
            if(this.activeFileRecord != null){
                this.activeNote = this.submissionHistoryService.getNotes(this.activeFileRecord.uuid).then(response => {
                             this.notesComponentSubmissionInfo.finalHeight = "20";
                             this.notesComponentSubmissionInfo.reset(this.activeFileRecord.uuid, response);
                         });
             }
        });
    }

    public getSampleSubmissionData(id: any): void {
        this.submissionHistoryService.getSampleSubmissionData(id);
    }

    copyMessage(e: any, val: string){
        if (this.btnTrigger) {
            this.btnTrigger.toggleClass('down');
        }
        this.btnTrigger = $(e.target);
        e.target.classList.add('down');
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    public displaySourceDialog(uuid: string, hmlId: string, uploaderFileName: string, submissionStatus: string): void {
        this.modalService.openSubmissionSourceDialog(uuid, hmlId, uploaderFileName, submissionStatus);
    }
}
